import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=peaceful%20dreamy%20bedroom%20at%20night%20with%20soft%20warm%20amber%20moonlight%20streaming%20through%20sheer%20curtains%2C%20cozy%20bed%20with%20fluffy%20cream%20white%20bedding%2C%20gentle%20atmosphere%2C%20minimalist%20interior%2C%20soft%20bokeh%20effect%2C%20warm%20cream%20and%20beige%20tones%2C%20cinematic%20photography%2C%20dreamy%20aesthetic&width=1800&height=1200&seq=hero-bg-01&orientation=landscape"
        alt="助眠 ASMR 深度放松入睡体验"
        title="助眠 ASMR 深度放松入睡体验"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/15 to-black/50" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs md:text-sm font-medium mb-6 tracking-wide border border-background-50/30">
          专业助眠 ASMR 内容精选平台
        </span>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
          用声音的力量
          <br />
          带您进入<strong className="text-primary-300">深度睡眠</strong>
        </h1>

        <p className="text-sm md:text-base text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          探索最有效的助眠 ASMR 内容精选，涵盖雨声、耳语、敲击等多种触发音效，
          帮助您快速放松神经、缓解失眠焦虑，每晚享受深度睡眠体验。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer no-underline"
          >
            探索 ASMR 分类
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/30 no-underline"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}